/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { ReactNode } from "react";
import "./VerticalSplitContainer.scss";

export interface VerticalSplitContainerProps {
    right: ReactNode;
    left?: ReactNode;
}

export default function VerticalSplitContainer({ right, left }: VerticalSplitContainerProps) {
    return (
        <div className="lan-verticalsplitcontainer">
            {left && <div className="lan-verticalsplitcontainer__left">{left}</div>}
            <div className="lan-verticalsplitcontainer__right">{right}</div>
        </div>
    );
}
